import './index.scss'
import AnimatedLetters from '../AnimatedLetters';
import { useState} from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo1 from '../../assets/images/logo1.png';
import logo2 from '../../assets/images/logo2.png';
import logo3 from '../../assets/images/logo3.png';
import logo4 from '../../assets/images/logo4.png';
import logo5 from '../../assets/images/logo5.png';
import logo6 from '../../assets/images/logo6.png';
import Loader from 'react-loaders';

const About = () => {

    const [letterClass, setLetterClass] = useState('text-animate');

    setTimeout(() => {
        setLetterClass('text-animate-hover');
    }, 3000);

    document.title = "Portfolio | About";

    return(
        <>
        <div className="container about-page">
            <div className="text-zone">
                <h1>
                    <AnimatedLetters letterClass={letterClass} myStr={"About"} idx={3} />{" "}
                    <AnimatedLetters letterClass={letterClass} myStr={"Me"} idx={2} />
                </h1>
                <p>I am currently a student at Jadavpur University, pursuing Computer Science and Engineering undergraduate course (2020 - 2024).</p>
                <p>I am a very versatile and ambitious person who enjoys learning new things everyday. I am also a capable team-player, and walk in the path of life with a forward-thinking mindset while picking up valuable experiences on the way.</p>
                <p>I am also really passionate about coding, and am looking forward to working in an established IT company to polish, enhance and upgrade my skills while working with the latest technologies, on challenging and diverse projects.</p>
            </div>

            <div className="stage-cube-cont">
                <div className="cubespinner">
                    <div className="face1">
                        <img src={logo1} alt="PYTHON3" />
                    </div>
                    <div className="face2">
                        <img src={logo2} alt="FLUTTER" />
                    </div>
                    <div className="face3">
                        <img src={logo3} alt="SOLANA BLOCKCHAIN" />
                    </div>
                    <div className="face4">
                        <img src={logo4} alt="CSS3" />
                    </div>
                    <div className="face5">
                        <img src={logo5} alt="RUST" />
                    </div>
                    <div className="face6">
                        <img src={logo6} alt="REACT JS" />
                    </div>
                </div>
            </div>
        </div>
        <Loader type="ball-spin-fade-loader" />
        </>
    );
}

export default About;